<template>
  <v-layout row wrap>
    <v-layout row justify-space-between>
      <v-flex grow>
        <h5>Fixed Cost for Customer</h5>
      </v-flex>
      <v-flex>
        <v-layout>
          <v-autocomplete
            v-model="customer"
            :items="customerList"
            :loading="loading"
            :search-input.sync="search"
            item-text="name"
            label="Customer Search"
            hide-no-data
            hide-selected
            no-filter
            return-object
            prepend-icon="mdi-database-search"
            @change="customerSelected"
          ></v-autocomplete>
          <v-btn
            class="text-none offset-align-select"
            color="blue"
            dark
            @click="addCustomer"
          >Add Customer</v-btn>
        </v-layout>
      </v-flex>
    </v-layout>
    <v-flex xs12>
      <v-expansion-panels>
        <v-expansion-panel v-for="(item,i) in fixedCostCustomers" :key="i">
          <v-expansion-panel-header>{{item.user.name}}</v-expansion-panel-header>
          <v-expansion-panel-content>
            <FixedCostDetails
              :rideTypes="rideTypes"
              :fixedCost="item.fixed_cost == null ? { fixed_cost_ride_type: []} : item.fixed_cost"
              :name="`Fixed Cost for ` + item.user.name"
              :forCustomer="true"
              :customer="item.user"
            >Fixed Cost #{{$route.params.id}}</FixedCostDetails>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-flex>
  </v-layout>
</template>

<script>
import FixedCostDetails from "@/components/settings/pricing/FixedCostDetails.vue";

import qs from "qs";
import axios from "axios";

axios.defaults.withCredentials = true;

export default {
  name: "fixed_cost_list",
  props: {
    fixedCostArea: Object,
    rideTypes: { type: Array, default: null }
  },
  components: {
    FixedCostDetails
  },
  computed: {
    fixedCostCustomers: function() {
      return this.fixedCostArea.fixed_cost_customer;
    },
    customerList: function() {
      var fixedCostArea = this.fixedCostArea;

      return this.customers.filter(function(customer) {
        var fixedCostCustomer = fixedCostArea.fixed_cost_customer.find(function(
          item
        ) {
          return item.user.id == customer.id;
        });

        return fixedCostCustomer == null;
      });
    }
  },
  watch: {
    search(val) {
      // Items have already been loaded
      // if (this.customers.length > 0) return;

      // Items have already been requested
      // if (this.loading) return;

      if (val == null) return;
      if (val.length <= 1) return;

      var url = `${this.$store.state.apiUrl}/customer/search?query=${val}`;

      var searchCompleted = this.searchCompleted;

      axios({
        url: url,
        method: "GET",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      })
        .then(function(res) {
          searchCompleted(res.data);
        })
        .catch(function(err) {
          console.error(err);
          this.loading = false;
        });
    }
  },
  data: function() {
    return {
      expanded: [],
      headers: [
        {
          text: "Customer Name",
          align: "left",
          sortable: false,
          value: "name"
        }
      ],
      loading: false,
      customers: [],
      customer: {},
      search: null
    };
  },
  methods: {
    searchCompleted: function(data) {
      this.customers = data.customers;

      this.loading = false;
    },
    customerSelected: function(customer) {
      console.log("Changed " + JSON.stringify(customer));
    },
    addCustomer: function() {
      // check if customer has already been added

      if (this.customer != null) {
        this.fixedCostArea.fixed_cost_customer.push({
          user: this.customer,
          id: Math.random(),
          fixed_cost: { fixed_cost_ride_type: [] }
        });

        this.customer = null;
      }

      console.log(JSON.stringify(this.fixedCostArea.fixed_cost_customer));
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
table.v-table tbody tr td {
  height: 19px;
  padding: 2px 3px !important;
}

thead th:not(:first-child) {
  padding: 0 4px;
}
</style>
